import { render, staticRenderFns } from "./cswiper.vue?vue&type=template&id=711d5784&"
import script from "./cswiper.vue?vue&type=script&lang=js&"
export * from "./cswiper.vue?vue&type=script&lang=js&"
import style0 from "./cswiper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports